// @ts-nocheck
import { getGardenInitialZoom } from "../utils/viewport";
import type { LegacyHeadstone } from "../utils/dto";
import type { WorldBounds } from "./viewport-bounds";

/** Placement deterministici di un chunk, calcolati una sola volta e riusati
 * a ogni (ri)generazione: i check spaziali (registerDecor & co.) non sono
 * idempotenti, quindi non vanno mai rieseguiti per lo stesso chunk. */
export type ChunkPlacements = {
  holes: { hid: string; x: number; y: number }[];
  decors: { x: number; y: number; sz: number; isTree: boolean }[];
  flowers: { x: number; y: number; sz: number; ci: number }[];
};

export const mapState = {
  camX: 0,
  camY: 0,
  zoomLevel: getGardenInitialZoom(),
  zoomStep: 0,
  selectedHole: null as HTMLElement | null,
  pendingPurchaseHole: null as HTMLElement | null,
  gravesData: {} as Record<string, LegacyHeadstone>,
  /** headstone id -> holeId, per lookup O(1) senza scan di gravesData. */
  graveIdToHole: new Map<string, string>(),
  population: 0,
  holeEls: {} as Record<string, HTMLElement>,
  holeBuckets: {} as Record<string, { x: number; y: number }[]>,
  decorBuckets: {} as Record<string, { x: number; y: number; r: number }[]>,
  genChunks: {} as Record<string, boolean>,
  /** Elementi DOM montati per chunk ("cx,cy"): permette l'unload dei chunk
   * fuori viewport (il DOM non deve crescere senza limite durante il pan). */
  chunkEls: {} as Record<string, HTMLElement[]>,
  chunkPlacements: {} as Record<string, ChunkPlacements>,
  /** Buche create fuori dalle regole procedurali (fallback per lapidi
   * backend): vanno ricreate quando il loro chunk viene rigenerato. */
  manualHoles: {} as Record<string, { hid: string; x: number; y: number }[]>,
  panMoved: false,
  isPanning: false,
  cemeteryLoadState: "idle" as "idle" | "loading" | "ready" | "error",
  loadedBboxes: [] as WorldBounds[],
};

export const mapRefs = {
  viewport: null as HTMLElement | null,
  world: null as HTMLElement | null,
  temple: null as HTMLElement | null,
};

export function initMapRefs(): void {
  mapRefs.viewport = document.getElementById("viewport");
  mapRefs.world = document.getElementById("world");
  mapRefs.temple = document.getElementById("temple");
  // Tempio al centro (offset per centrare visivamente l'immagine)
  if (mapRefs.temple) {
    mapRefs.temple.style.left = "-110px";
    mapRefs.temple.style.top = "-195px";
  }
}
